(() => {
  'use strict';
  const dialog = document.getElementById('sculp-info');
  if (!dialog) return;
  let origin;
  const messages = {
    'Contacto': 'Ginkgo biloba. Información sobre el producto, los packs y los envíos.',
    'Envíos': 'Todos los packs incluyen envío sin cargo. La entrega se coordina según la localidad de destino.',
    'Política de privacidad': 'El carrito y las reseñas que escribís se guardan en tu navegador.',
    'Términos y condiciones': 'Los packs incluyen la cantidad de cápsulas y el precio total indicados en la página. Revisá tu selección antes de continuar.',
    'Cambios y devoluciones': 'Consultá la información de garantía y las condiciones aplicables antes de realizar tu compra.'
  };
  document.querySelectorAll('[data-sculp-info]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    origin = link;
    const title = link.dataset.sculpInfo || link.textContent.trim() || 'Ginkgo biloba';
    const heading = dialog.querySelector('h2');
    const copy = dialog.querySelector('p');
    if (heading) heading.textContent = title;
    if (copy) copy.textContent = messages[title] || 'Conocé los packs, la presentación y las características de Ginkgo biloba.';
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('sculp-dialog-open');
  }));
  dialog.querySelectorAll('.sculp-dialog-close,.sculp-dialog-dismiss').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => { document.body.classList.remove('sculp-dialog-open'); origin?.focus(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
})();
